export default "__VITE_ASSET__CQm_4$ta__"